import axios from 'axios';
import { TOKEN_KEY } from './auth';

// Set proper default values for API endpoints
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const CARMODELS_ENDPOINT = '/car-models';

// Debug configuration
console.log('CarModel API Configuration:');
console.log('API URL:', API_URL);
console.log('CARMODELS ENDPOINT:', CARMODELS_ENDPOINT);

// Create axios instance
const api = axios.create({
  baseURL: API_URL
});

// Add request interceptor to attach the token to all requests
api.interceptors.request.use(config => {
  console.log('API Request:', config.method, config.url);
  
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    // Set the Authorization header with 'Bearer ' prefix
    config.headers.Authorization = `Bearer ${token}`;
    console.log('Token attached to request');
  } else {
    console.log('No token found in localStorage');
  }
  
  return config;
}, error => {
  console.error('Request interceptor error:', error);
  return Promise.reject(error);
});

// Get all car models with optional filtering by car make
export const getAllCarModels = async (options = {}) => {
  console.log('Calling getAllCarModels() with options:', options);
  const { carMakeId, all = true, activeOnly = false } = options;
  
  try {
    // Add query parameters
    const queryParams = new URLSearchParams();
    if (carMakeId) queryParams.append('carMakeId', carMakeId);
    if (all) queryParams.append('all', 'true');
    if (activeOnly) queryParams.append('active', 'true');
    
    const queryString = queryParams.toString();
    const endpoint = queryString ? `${CARMODELS_ENDPOINT}?${queryString}` : CARMODELS_ENDPOINT;
    
    console.log('Fetching car models from endpoint:', endpoint);
    const response = await api.get(endpoint);
    console.log('Car models fetched:', response.data.length);
    return response.data;
  } catch (error) {
    console.error('Error fetching car models:', error);
    throw error;
  }
};

// Get a single car model by id
export const getCarModel = async (id) => {
  console.log(`Calling getCarModel(${id})`);
  try {
    const response = await api.get(`${CARMODELS_ENDPOINT}/${id}`);
    console.log('Car model fetched:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching car model with id ${id}:`, error);
    throw error;
  }
};

// Create a new car model (manager only)
export const createCarModel = async (carModelData) => {
  console.log('Calling createCarModel() with data:', carModelData);
  try {
    const response = await api.post(CARMODELS_ENDPOINT, carModelData);
    console.log('Car model created:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating car model:', error);
    throw error;
  }
};

// Update a car model (manager only)
export const updateCarModel = async (id, carModelData) => {
  console.log(`Calling updateCarModel(${id}) with data:`, carModelData);
  try {
    const response = await api.put(`${CARMODELS_ENDPOINT}/${id}`, carModelData);
    console.log('Car model updated:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error updating car model with id ${id}:`, error);
    throw error;
  }
};

// Delete a car model (manager only)
export const deleteCarModel = async (id) => {
  console.log(`Calling deleteCarModel(${id})`);
  try {
    const response = await api.delete(`${CARMODELS_ENDPOINT}/${id}`);
    console.log('Car model deleted:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error deleting car model with id ${id}:`, error);
    throw error;
  }
}; 